// import atendimentoA from '@/assets/js/atendimento'
import Vue from 'vue'
import * as CoordenadasAtendimentoService from '@/services/CoordenadasAtendimento';

export default {
    namespaced: true,
    state: {
        atendimento: {},
        statusAtendimento: '',
        erro: false,
        chegadaConfirmada: '',
        idAtendimentoUrl: '',
        temServicos: false,
        totalServicos: 0,
        temAnexos: false,
        apiLoaded: false,
        coordenadasAtendimento: {}
    },
    getters: {
        dadosAtendimento(state) {
            return state.atendimento;
        },
        servicos(state) {
            return state.atendimento.servicos;
        },
        statusAtendimento(state) {
            return state.atendimento.status;
        },
        textoStatusAtendimento(state) {
            return state.atendimento.textoStatus;
        },
        nomeAssistencia(state) {
            return state.atendimento.assistencia;
        },
        whatsappContato(state) {
            return state.atendimento.whatsappContato;
        },
        telefoneContato(state) {
            return state.atendimento.telefoneContato;
        },
        anexos(state) {
            return state.atendimento.anexos;
        },
        expirado(state) {
            return state.atendimento.expirado;
        },
        enviarContatoWhatsapp(state) {
            return state.atendimento.enviarContatoWhatsapp;
        }
    },
    mutations: {
        setAtendimento(state, payload) {
            state.atendimento = payload;
        },
        setItemAtendimento(state, payload) {
            state.atendimento[payload.chave] = payload.item;
        },
        setExibirErro(state, erro) {
            state.erro = erro;
        },
        setDataHoraChegada(state, payload) {
            state.atendimento.servicos[payload.idServicoAtendimento].dataHorarioChegada = payload.dataHoraChegada;
        },
        setChegadaConfirmada(state, chegou) {
            state.chegadaConfirmada = chegou;
        },
        setIdAtendimentoUrl(state, id) {
            state.idAtendimentoUrl = id;
        },
        setTemServicos(state, temServicos) {
            state.temServicos = temServicos;
        },
        setTotalServicos(state, totalServicos) {
            state.totalServicos = totalServicos;
        },
        setTemAnexos(state, temAnexos) {
            state.temAnexos = temAnexos;
        },
        setApiLoaded(state, loaded) {
            state.apiLoaded = loaded;
        },
        setCoordenadasAtendimento(state, coordenadasAtendimento) {
            state.coordenadasAtendimento = coordenadasAtendimento;
        },
    },
    actions: {
        buscarDadosAtendimento({ commit }, {idAtendimento, atualizar}) {
            Vue.prototype.$http.get(`${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}?atualizar=${atualizar}`)
                .then(response => {
                    // console.log(response);
                    commit('setIdAtendimentoUrl', idAtendimento);
                    commit('setAtendimento', response.data);
                    if (response.data.expirado == 'N') {
                        commit('setExibirErro', false);

                        const totalServicos = Object.keys(response.data.servicos).length;
                        commit('setTemServicos', (totalServicos > 0));
                        commit('setTotalServicos', totalServicos);
                        
                        commit('setTemAnexos', (Object.keys(response.data.anexos).length > 0));
                    }
                    commit('setCoordenadasAtendimento', CoordenadasAtendimentoService.montarCoordenadasAtendimento(response.data));
                    commit('setApiLoaded', true);
                })
                .catch(error => {
                    console.error(error);
                    commit('setExibirErro', true);
                });
        },
        atualizarEnderecoAtendimento({ commit, state }, payload) {
            let endereco = {};

            if (payload.chave == 'enderecoOrigem') {
                endereco.origem = payload.item;
            }
            if (payload.chave == 'enderecoDestino') {
                endereco.destino = payload.item;
            }

            return Vue.prototype.$http.patch(`${process.env.VUE_APP_URL_API}/client/atendimento/${state.idAtendimentoUrl}/endereco`, endereco)
                .then(response => {
                    commit('setItemAtendimento', payload);
                    return Vue.prototype.$func.mensagemRetorno(false, response, 'Endereço enviado com sucesso');
                })
                .catch(error => {
                    return Vue.prototype.$func.mensagemRetorno(true, error, 'Erro ao enviar o endereço');
                });
        },
        enviarMarcacaoChegada({ commit, state }, payload) {
            return Vue.prototype.$http.put(`${process.env.VUE_APP_URL_API}/client/atendimento/${state.idAtendimentoUrl}/servico/${payload.idServicoAtendimento}/chegada/marcar`, { dataHoraChegada: payload.dataHoraChegada })
                .then(response => {
                    commit('setDataHoraChegada', payload);
                    return Vue.prototype.$func.mensagemRetorno(false, response, 'Chegada marcada com sucesso');
                })
                .catch(error => {
                    return Vue.prototype.$func.mensagemRetorno(true, error, 'Erro ao enviar a marcação da chegada');
                });
        },
        enviarConfirmacaoChegada({ commit, state }, payload) {
            return Vue.prototype.$http.put(`${process.env.VUE_APP_URL_API}/client/atendimento/${state.idAtendimentoUrl}/servico/${payload.idServicoAtendimento}/chegada/confirmar`, { chegou: payload.chegou })
                .then(response => {
                    commit('setChegadaConfirmada', payload.chegou);
                    return Vue.prototype.$func.mensagemRetorno(false, response, 'Confirmação de chegada enviada');
                })
                .catch(error => {
                    return Vue.prototype.$func.mensagemRetorno(true, error, 'Erro ao enviar a confirmação da chegada');
                });
        }
    }
}